import { SliceZone } from "@prismicio/react"
import classNames from "classnames"
import React from "react"

import { Header } from "./Header"
import type { Interpolations } from "../../../../../libs/prismic/helpers"
import { ProductBanner } from "../ProductBanner/ProductBanner"
import type { FormattedBlogPost } from "@/libs/prismic/types"
import { components } from "@/slices"
import type { Breadcrumb } from "@/types"

export type ArticleProps = {
  article: FormattedBlogPost
  breadcrumbs: Breadcrumb[]
  interpolations?: Interpolations
  className?: string
}

export const Article = ({ article, breadcrumbs, interpolations, className }: ArticleProps) => (
  <article className={classNames("w-full px-6 xl:pr-12", className)}>
    <Header article={article} breadcrumbs={breadcrumbs} />
    <div className="mt-8 w-full overflow-x-hidden">
      {article.body.map((slice, i) => (
        <React.Fragment key={i}>
          <SliceZone slices={[slice]} components={components} context={{ interpolations }} />
          {/* Mobile - Banner after the first content section */}
          {i === 0 && article.body.length > 1 && (
            <ProductBanner product={article.product} showImage={false} className="my-4 flex w-full xl:hidden" />
          )}
        </React.Fragment>
      ))}
    </div>
    <ProductBanner product={article.product} showImage={false} className="mt-10 xl:hidden" />
  </article>
)
